import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import votingReducer from './slices/votingSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'], // Solo lo stato auth viene persistito
};

const rootReducer = combineReducers({
  auth: authReducer,
  voting: votingReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        ignoredActionsPaths: ['payload.createdAt', 'payload.lastVoteTime'],
        ignoredPaths: ['auth.user.createdAt', 'auth.user.lastVoteTime'],
        isSerializable: (value) => {
          // Allow Firebase Timestamp objects
          if (value && typeof value === 'object' && value.constructor && value.constructor.name === 'Timestamp') {
            return true;
          }
          return true;
        },
      },
    }),
});

export const persistor = persistStore(store);

// Type definitions removed for JavaScript compatibility
// For TypeScript projects, uncomment the following lines:
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;